<template>
    <svg viewBox="0 0 24 24" class="w-6 h-6"><path fill="currentColor" d="M14,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V8L14,2m4,18H6V4h7V9h5V20"></path><rect fill="currentColor" x="7.94" y="12.75" width="8.09" height="1.54" transform="translate(23.96 27.04) rotate(180)"></rect><rect fill="currentColor" x="6.25" y="13.52" width="8.09" height="1.54" transform="translate(-4 24.58) rotate(-90)"></rect></svg>
</template>

<script setup>
</script>